import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'orderBy'})
export class OrderByPipe implements PipeTransform {
  transform(array, orderBy, asc = true) {
    if (!orderBy || orderBy.trim() == "") {
      return array;
    } 
    if (asc) {
      return array.sort((a: any, b: any) => { 
        return this.orderByComparator(a[orderBy], b[orderBy]);
      });
    } else {
      return array.sort((a: any, b: any) => { 
        return this.orderByComparator(b[orderBy], a[orderBy]);
      });
    }
  }
  orderByComparator(a: any, b: any): number {
    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
      if (a < b) return -1;
      if (a > b) return 1;
    } else {
      if (parseFloat(a) < parseFloat(b)) return -1;
      if (parseFloat(a) > parseFloat(b)) return 1;
    }
    return 0;
  }
}